import React from 'react'

import Color from 'helpers/Color'
import {
  Grid,
  Chart,
} from 'components/UI'

const fanOnItem = [
  { label: 'Fans On', color: Color.lightGreen },
]

const legendItems = [
  { label: 'Room Temperature', color: Color.darkGray },
  { label: 'Radiator Temperature', color: Color.gray },
]

const LineChartTitle = ({ title, showFans }) => {
  const items = [
    ...legendItems,
    ...(showFans ? fanOnItem : []),
  ]

  return (
    <Grid.Row>
      <Grid.Col>
        <h2>{title}</h2>
      </Grid.Col>
      <Grid.Col>
        <Chart.LineLegend items={items} />
      </Grid.Col>
    </Grid.Row>
  )
}

export default LineChartTitle



// WEBPACK FOOTER //
// ./src/components/UI/Chart/LineChartTitle.jsx